import { render, staticRenderFns } from "./RequestSheetTab.vue?vue&type=template&id=66d4c0da&scoped=true&"
import script from "./RequestSheetTab.vue?vue&type=script&lang=ts&"
export * from "./RequestSheetTab.vue?vue&type=script&lang=ts&"
import style0 from "./RequestSheetTab.vue?vue&type=style&index=0&id=66d4c0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4c0da",
  null
  
)

export default component.exports